(() => {
  function init(builder) {
    if (builder.dataset.compareReady || !window.TexanShopping) return;
    const S = window.TexanShopping;
    const text = JSON.parse(builder.querySelector('[data-compare-text]').textContent);
    const catalog = JSON.parse(builder.querySelector('[data-compare-data]').textContent).filter(item => item.handle);
    const root = builder.dataset.root || '/';
    const B = window.TexanBuyingConfidence;
    const labels = B?.text || {};
    const showroom = builder.querySelector('[data-compare-showroom]');
    const fitting = builder.querySelector('[data-compare-fitting]');
    const copy = builder.querySelector('[data-compare-copy]');
    const handoffStatus = builder.querySelector('[data-compare-handoff-status]');
    if (showroom && B?.showroomPreference()) showroom.value = B.showroomPreference();
    const sizeSelect = builder.querySelector('[data-compare-size]');
    const slots = ['a', 'b', 'c'];
    const selects = slots.map(slot => builder.querySelector('[data-compare-select="' + slot + '"]'));
    const cards = slots.map(slot => builder.querySelector('[data-compare-card="' + slot + '"]'));
    const sequences = [0, 0, 0];
    const selections = [null, null, null];
    const params = new URLSearchParams(location.search);
    const requested = (params.get('compare') || '').split(',').filter(Boolean).slice(0, 3);
    const requestedVariants = slots.map((slot,index) => params.get('v' + (index + 1)) || '');
    const requestedSize = S.size(params.get('size'));
    if (requestedSize) sizeSelect.value = requestedSize;
    builder.dataset.compareReady = 'true';
    function addOption(product) {
      if (!product.handle || catalog.some(item => item.handle === product.handle && item.added)) return;
      selects.forEach(select => { const option = S.node('option', product.title); option.value = product.handle; select.appendChild(option); });
      const known = catalog.find(item => item.handle === product.handle);
      if (known) known.added = true; else catalog.push({ ...product, added: true });
    }
    [...catalog].forEach(addOption);
    const defaults = ['helix-midnight-luxe', 'the-winkbed', ''];
    function status() {
      const active = selects.filter(select => select.value);
      builder.querySelector('[data-compare-grid]').dataset.count = String(active.length);
      builder.querySelector('[data-compare-status]').textContent = sizeSelect.value + ' · ' + active.length + ' ' + text.count;
      const url = new URL(location.href); url.searchParams.set('compare', active.map(select => select.value).join(',')); url.searchParams.set('size', sizeSelect.value);
      selections.forEach((selection,index) => {
        const key = 'v' + (index + 1);
        if (selection?.variant) url.searchParams.set(key,String(selection.variant.id)); else url.searchParams.delete(key);
      });
      history.replaceState(null, '', url);
      selects.forEach(select => [...select.options].forEach(option => { option.disabled = Boolean(option.value && selects.some(other => other !== select && other.value === option.value)); }));
    }
    function setField(card, key, value) { const field = card.querySelector('[data-compare-field="' + key + '"]'); if (field) field.textContent = value || text.confirm; }
    function updateComparison() {
      status();
      const active = selects.filter(select => select.value).length;
      const complete = selections.filter(selection => selection?.variant);
      const ready = active >= 2 && complete.length === active;
      const sameCurrency = new Set(complete.map(selection => selection.product.currency)).size <= 1;
      copy.disabled = !ready;
      fitting.setAttribute('aria-disabled', String(!ready));
      handoffStatus.textContent = ready ? labels.saved : labels.select_two;
      const minimum = ready && sameCurrency ? Math.min(...complete.map(selection => selection.variant.price * selection.quantity)) : null;
      selections.forEach((selection,index) => {
        const delta = cards[index].querySelector('[data-compare-field="delta"]');
        delta.hidden = minimum === null || !selection?.variant;
        if (!delta.hidden) {
          const difference = selection.variant.price * selection.quantity - minimum;
          delta.textContent = difference ? labels.extra + ' ' + S.money(difference,selection.product.currency) : labels.lowest;
        }
      });
      if (!ready) { B?.setComparison(null); fitting.href = root + 'pages/book-mattress-fitting'; return; }
      const payload = { version:1, createdAt:Date.now(), root, size:sizeSelect.value, sourceUrl:location.href, items:complete.map(selection => ({
        handle:selection.product.handle, title:selection.product.title, variantId:selection.variant.id,
        configuration:selection.variant.title, quantity:selection.quantity, url:S.link(selection.product,selection.variant)
      })) };
      B?.setComparison(payload);
      fitting.href = B ? B.fittingUrl(payload,showroom.value) : root + 'pages/book-mattress-fitting';
    }
    showroom?.addEventListener('change',updateComparison);
    fitting?.addEventListener('click',event => {
      if (fitting.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      const payload = B?.getComparison();
      if (payload) B.save(payload);
    });
    copy?.addEventListener('click',async () => {
      try { await navigator.clipboard.writeText(location.href); handoffStatus.textContent = labels.copied; }
      catch { handoffStatus.textContent = labels.copy_error; }
    });
    function draw(index, product, variant, list) {
      const card = cards[index];
      const pair = list.quantity;
      selections[index] = { product, variant, quantity: pair };
      card.setAttribute('aria-busy', 'false');
      const image = card.querySelector('[data-compare-field="image"]'); image.src = product.image; image.alt = product.title;
      for (const key of ['title', 'vendor', 'construction']) setField(card, key, product[key]);
      const view = card.querySelector('[data-compare-field="link"]'); view.href = S.link(product, variant);
      card.querySelector('[data-compare-options]').replaceChildren();
      if (!variant) {
        setField(card, 'price', text.no_size); setField(card, 'configuration', sizeSelect.value);
        for (const key of ['compare', 'savings']) { const field = card.querySelector('[data-compare-field="' + key + '"]'); field.textContent = ''; }
      } else {
        S.options(card.querySelector('[data-compare-options]'), product, list.variants, variant, next => draw(index, product, next, list), 'tx-compare-option-' + index);
        setField(card, 'price', S.money(variant.price * pair, product.currency));
        const original = variant.compareAt * pair;
        const savings = Math.max(0, original - variant.price * pair);
        card.querySelector('[data-compare-field="compare"]').textContent = savings ? S.money(original, product.currency) : '';
        card.querySelector('[data-compare-field="savings"]').textContent = savings ? text.save + ' ' + S.money(savings, product.currency) : '';
        setField(card, 'configuration', (pair === 2 ? text.pair + ' · ' : '') + variant.title + (variant.available ? '' : ' · ' + text.unavailable));
      }
      const feel = variant?.options.map(value => product.feels?.[value] || product.feels?.[String(value).split(' (')[0]]).find(Boolean);
      setField(card, 'firmness', feel?.firmness || (typeof product.firmness === 'number' ? product.firmness + '/10' : product.firmness));
      setField(card, 'bestFor', feel?.bestFor || product.bestFor);
      setField(card, 'choose', feel?.bestFor || product.choose || product.bestFor);
      setField(card, 'tradeoff', feel?.tradeoff || product.tradeoff);
      setField(card, 'upgrade', product.upgrade);
      const source = card.querySelector('[data-compare-field="source"]');
      source.hidden = !product.source;
      if (product.source) source.href = product.source;
      const coolingIndex = product.options.findIndex(option => /cool|cover|frost|fabric/i.test(option.name));
      const coolingOption = coolingIndex >= 0 && variant ? variant.options[coolingIndex] : '';
      setField(card, 'cooling', coolingOption || product.cooling);
      setField(card, 'showrooms', Array.isArray(product.showrooms) && product.showrooms.length ? product.showrooms.join(' · ') : text.confirm_display);
      setField(card, 'delivery', product.delivery);
      updateComparison();
    }
    async function render(index) {
      const seq = ++sequences[index];
      const handle = selects[index].value;
      const previous = selections[index];
      const requestedVariant = requestedVariants[index];
      requestedVariants[index] = '';
      selections[index] = null;
      cards[index].hidden = !handle;
      if (!handle) { updateComparison(); return; }
      cards[index].setAttribute('aria-busy', 'true');
      setField(cards[index], 'price', text.loading);
      updateComparison();
      try {
        const product = await S.load(root, handle);
        if (seq !== sequences[index]) return;
        const list = S.candidates(product, sizeSelect.value, true);
        const preferences = previous?.product.handle === handle ? [...(previous.variant?.options || [])] : [];
        if (list.index >= 0) preferences[list.index] = null;
        const selected = requestedVariant ? list.variants.find(variant => String(variant.id) === requestedVariant) || null : S.choose(list.variants,preferences);
        draw(index, product, selected, list);
      } catch (error) {
        if (seq !== sequences[index]) return;
        cards[index].setAttribute('aria-busy', 'false');
        setField(cards[index], 'price', text.error);
        setField(cards[index], 'title', catalog.find(item => item.handle === handle)?.title || handle);
        cards[index].querySelector('[data-compare-field="link"]').href = S.productUrl(root, handle);
        updateComparison();
      }
    }
    async function boot() {
      await Promise.allSettled(requested.filter(handle => !catalog.some(item => item.handle === handle)).map(handle => S.load(root, handle).then(addOption)));
      selects.forEach((select, index) => {
        select.value = requested[index] && catalog.some(item => item.handle === requested[index]) ? requested[index] : catalog.some(item => item.handle === defaults[index]) ? defaults[index] : index === 2 ? '' : catalog[index]?.handle || '';
        if (index && selects.slice(0, index).some(other => other.value === select.value)) select.value = index === 2 ? '' : catalog.find(item => !selects.slice(0, index).some(other => other.value === item.handle))?.handle || '';
        select.addEventListener('change', () => render(index));
      });
      sizeSelect.addEventListener('change', () => slots.forEach((slot, index) => render(index)));
      slots.forEach((slot, index) => render(index));
    }
    boot();
  }
  const boot = () => document.querySelectorAll('[data-tx-compare-builder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

